import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { TwoFactorDialogComponent } from 'src/app/dialogs/profile/two-factor-dialog/two-factor-dialog.component';
import { UsersService } from 'src/app/services/users/users.service';
import { AdditionalAction } from 'src/app/shared/payee-cases/cases-table/cases-table.component';
import { ClientOption, Stage } from 'src/app/shared/payee-cases/types';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { PayeeIconButtonComponent } from '../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeIconComponent } from '../../shared/payee-icon/payee-icon.component';
import { PayeeButtonComponent } from '../../shared/payee-buttons/payee-button/payee-button.component';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { PayeeCasesComponent } from '../../shared/payee-cases/payee-cases.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClientsService } from 'src/app/services/clients/clients.service';

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss'],
  imports: [
    PayeeIconButtonComponent,
    PayeeIconComponent,
    PayeeButtonComponent,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    PayeeCasesComponent,
    TranslateModule,
  ],
})
export class CasesComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private usersService = inject(UsersService);
  private dialog = inject(MatDialog);
  private clientsService = inject(ClientsService);

  private readonly destroy = new Subject<void>();
  readonly getCasesPath = 'api/case';
  readonly getDebtorsPath = 'api/debtor';

  readonly stages: Stage[] = ['ongoing', 'closed'];
  readonly additionalActions: AdditionalAction[] = [];

  userName?: string = 'Ügyvéd';
  has2FA = false;

  readonly searchClients = async (name: string): Promise<ClientOption[]> => {
    const result = await this.clientsService.searchClients({ name });
    return result.clients;
  };

  readonly resolveClient = async (
    uuid: string,
  ): Promise<ClientOption | null> => {
    try {
      return await this.clientsService.getClient(uuid);
    } catch {
      return null;
    }
  };

  ngOnInit(): void {
    this.usersService.userSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((user) => {
        this.userName = user?.name ?? 'Ügyvéd';
        this.has2FA = user?.has_2fa ?? false;
      });
  }

  manageMFA(): void {
    this.dialog.open(TwoFactorDialogComponent, {
      autoFocus: false,
      data: { has2FA: this.has2FA },
      position: {
        top: '50px',
      },
    });
  }

  async logout(): Promise<void> {
    await this.authService.logout();
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
